import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'
import { Accordion } from '@ui/components/Accordion'

import styles from './WithdrawalTips.module.scss'

export const WithdrawalTips: React.FC = () => {
  const { t } = useTranslation()

  const tips = [
    t('Wallet.Use a payment method you have previously deposited with'),
    t('Wallet.Some methods can only receive up to deposited amount'),
    t('Wallet.Submit card withdrawal first up to deposit amount'),
  ]

  return (
    <Accordion title={t('Wallet.Tips for smooth withdrawals')} fullWidth>
      <ul className={styles.tipsList}>
        {tips.map((tip) => (
          <li key={tip}>
            <Body2 color='text-med-em'>{tip}</Body2>
          </li>
        ))}
      </ul>
    </Accordion>
  )
}
